export const toUpperCase = (input: string) => {
	if (typeof input === 'string') {
		return input.toUpperCase();
	}
	return null;
};
